import React from 'react';
import { BookOpen, Shield, Zap, MessageCircle } from 'lucide-react';
export function ProductRevealSection() {
  return <section className="py-24 bg-surface border-y border-border relative overflow-hidden" data-id="element-128">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent-orange/5 rounded-full blur-[100px] pointer-events-none" data-id="element-129"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-130">
        <div className="text-center mb-16" data-id="element-131">
          <p className="text-accent-yellow font-bold tracking-widest uppercase mb-4" data-id="element-132">
            Introducing
          </p>
          <h2 className="font-heading text-6xl md:text-8xl text-primary mb-6" data-id="element-133">
            THE SOCIAL <br className="md:hidden" data-id="element-134" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-yellow to-accent-orange" data-id="element-135">
              SURVIVAL SCRIPT
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-muted max-w-3xl mx-auto" data-id="element-136">
            The first-ever tactical manual designed to hand you the exact words
            to say when the pressure is on.
          </p>
        </div>

        {/* Mockup / Visual Representation */}
        <div className="relative mx-auto max-w-4xl bg-background border border-border rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-137">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-138">
            <div className="space-y-6" data-id="element-139">
              <h3 className="font-heading text-3xl text-primary" data-id="element-140">
                NOT A COURSE. <br data-id="element-141" />
                <span className="text-accent-orange" data-id="element-142">AN IDENTITY UPGRADE.</span>
              </h3>
              <p className="text-muted" data-id="element-143">
                This isn't a 6-month grammar course. This is a tactical toolkit
                you can read in an afternoon and use tonight.
              </p>
              <div className="space-y-4 pt-4" data-id="element-144">
                <div className="flex items-center gap-4" data-id="element-145">
                  <div className="w-12 h-12 rounded-full bg-accent-yellow/10 flex items-center justify-center text-accent-yellow" data-id="element-146">
                    <BookOpen size={24} data-id="element-147" />
                  </div>
                  <div data-id="element-148">
                    <h4 className="font-bold text-primary" data-id="element-149">
                      50+ Battle-Tested Scripts
                    </h4>
                    <p className="text-sm text-muted" data-id="element-150">
                      Exact phrases for every social situation.
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-151">
                  <div className="w-12 h-12 rounded-full bg-accent-orange/10 flex items-center justify-center text-accent-orange" data-id="element-152">
                    <Shield size={24} data-id="element-153" />
                  </div>
                  <div data-id="element-154">
                    <h4 className="font-bold text-primary" data-id="element-155">
                      The "Wait, What?" Shield
                    </h4>
                    <p className="text-sm text-muted" data-id="element-156">
                      Handle confusion without looking lost.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Abstract Book Cover / Product Visual */}
            <div className="aspect-[3/4] bg-gradient-to-br from-surface to-background rounded-lg border border-border flex items-center justify-center relative shadow-2xl transform md:rotate-3 hover:rotate-0 transition-transform duration-500" style={{
            boxShadow: '0 0 40px rgba(0,214,143,0.15)'
          }} data-id="element-157">
              <div className="absolute inset-0 border-2 border-accent-yellow/20 rounded-lg m-2" data-id="element-158"></div>
              <div className="text-center p-8" data-id="element-159">
                <span className="font-heading text-6xl text-primary opacity-20 absolute top-4 left-4" data-id="element-160">
                  SSS
                </span>
                <h3 className="font-heading text-5xl text-accent-yellow mb-2" data-id="element-161">
                  SOCIAL
                  <br data-id="element-162" />
                  SURVIVAL
                  <br data-id="element-163" />
                  SCRIPT
                </h3>
                <p className="text-muted text-sm uppercase tracking-widest mt-4" data-id="element-164">
                  The Manual for
                  <br data-id="element-165" />
                  ESL Professionals
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}